import handleMethod from '../Utils/APIutils/handleMethod';

class AlertAPI {
  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/alerts/${id}` });
  }

  async list(page = 1, itemsPerPage = 20) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/alerts?page=${page}&itemsPerPage=${itemsPerPage}` });
  }

  async getUnresolvedByClient(clientId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/alerts/unresolved/client/${clientId}` });
  }

  async getUnresolvedByStore(storeId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/alerts/unresolved/store/${storeId}` });
  }

  async resolve(id) {
    return handleMethod({ type: 'PATCH', method: `api/gatewaycontagem/alerts/${id}/resolve` });
  }

  async bulkResolve(alertIds) {
    return handleMethod({ type: 'PATCH', method: 'api/gatewaycontagem/alerts/resolve/bulk', params: { alertIds } });
  }

  // Alert configurations
  async getConfigs(clientId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/alerts/configurations/${clientId}` });
  }

  async createConfig(data) {
    return handleMethod({ type: 'POST', method: 'api/gatewaycontagem/alerts/configurations', params: data });
  }

  async updateConfig(id, data) {
    return handleMethod({ type: 'PUT', method: `api/gatewaycontagem/alerts/configurations/${id}`, params: data });
  }

  async deleteConfig(id) {
    return handleMethod({ type: 'DELETE', method: `api/gatewaycontagem/alerts/configurations/${id}` });
  }
}

export const alertAPI = new AlertAPI();
